import { styled } from 'styled-system/jsx'

const ChipButton = styled('button', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    fontWeight: '600',
    paddingX: '10px',
    paddingY: '5px',
    borderRadius: 'pill',
    border: '1.5px solid',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '5px',
    transition:
      'transform {durations.fast} {easings.appleStandard}, background-color {durations.fast} {easings.appleStandard}, color {durations.fast} {easings.appleStandard}, border-color {durations.fast} {easings.appleStandard}',
    _hover: {
      transform: 'translateY(-1px)',
    },
    _active: {
      transform: 'translateY(0) scale(0.96)',
    },
  },
  variants: {
    size: {
      sm: {
        fontSize: '11px',
        paddingX: '8px',
        paddingY: '3px',
      },
      md: {
        fontSize: '12px',
        paddingX: '10px',
        paddingY: '5px',
      },
    },
    tone: {
      untagged: {
        color: 'quickpass.inkSoft',
        backgroundColor: 'transparent',
        borderColor: '#E5E0F5',
        _hover: {
          borderColor: 'quickpass.primary',
          color: 'quickpass.primary',
        },
      },
      yes: {
        color: '#FFFFFF',
        backgroundColor: 'quickpass.success',
        borderColor: 'quickpass.success',
      },
      maybe: {
        color: '#7B5A1A',
        backgroundColor: 'quickpass.celebration',
        borderColor: 'quickpass.celebration',
      },
      no: {
        color: '#FFFFFF',
        backgroundColor: 'quickpass.warmth',
        borderColor: 'quickpass.warmth',
      },
    },
  },
  defaultVariants: {
    size: 'md',
    tone: 'untagged',
  },
})

const Glyph = styled('span', {
  base: {
    fontSize: '13px',
    lineHeight: '1',
  },
})

export { ChipButton, Glyph }
